import { z } from 'zod';
import { QTY_SCALE } from '../../utils/quantity-scale.js';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
export const MAX_WORK_ORDERS_PER_LINE = 50;
// WHY: entries deliberately need not sum to qtyToFulfill — Q14 surfaces the gap rather than rejecting it.
export const splitQuantitiesSchema = z
    .array(z
    .number()
    .finite()
    .max(MANUFACTURING_ORDER_CONSTRAINTS.quantity.max, `Each work order quantity must be ${MANUFACTURING_ORDER_CONSTRAINTS.quantity.max.toLocaleString('en-US')} or less.`)
    .transform((value) => Math.round(value * QTY_SCALE) / QTY_SCALE)
    .refine((value) => value > 0, 'Each work order quantity must be greater than zero.'))
    .max(MAX_WORK_ORDERS_PER_LINE, `A line can be split across at most ${MAX_WORK_ORDERS_PER_LINE} work orders.`);
//# sourceMappingURL=split-quantities.js.map